import BaseRoot from "./styled";
export default BaseRoot;